import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  constructor(
   // private authService: AuthService,
    private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const map =  JSON.parse(localStorage.getItem("authMap"));
      let isAdmin = localStorage.getItem("isAdmin")==='true' ? true : false;
      if (isAdmin || (map ? map[state.url.replace('/','').toLowerCase()] : false)) {
        return true;
      }
      else{
          this.router.navigate(['/unauthorized-page']);
          return false;
      }
  }
}